import type { BlockDefinition } from '#layers/block-engine/types/block';
import { shallowRef } from 'vue';

export type BuiltinBlockRegistry = Readonly<Record<string, BlockDefinition>>;

const registry = shallowRef<BuiltinBlockRegistry>({});

export function registerBuiltinBlocks(blocks: BuiltinBlockRegistry) {
	registry.value = blocks;
}

export function getBuiltinBlocks(): BuiltinBlockRegistry {
	return registry.value;
}
